import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/conexaolivre",

        async list({ pagination }) {
            const url = this.userUrl({
                path: `/${pagination.page}/${pagination.amountPerPage}`
            });
            return await Vue.http.get(url);
        },

        async count() {
            const url = this.userUrl({ path: `/paginacao` });

            return await Vue.http.get(url);
        },

        async create(data) {
            return await Vue.http.post(this.url(), data);
        },

        async remove(id) {
            const url = this.userUrl({ path: `/${id}` });
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http.delete(url).catch(error => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        }
    },
    base
);
